<template>
<div class="banner banner--desktop-middle-center not-found">
        <div class="banner__content" style="align-items: center!important;">
            <div class="banner__layout center-align">
                <h1 class="title-xl text-rothcoBlack">404</h1>
                <p class="paragraph-default text-rothcoBlack">The page you are looking for does not exist.</p>
            </div>
        </div>
</div>
<div class="best-sller-carousel">
            <product-carousel :heading="bestSellerHeading" ref="productCarouselRef" :togglePadding="true" :isBestSellers="true" allowQuickView/>
</div>
</template>

<script lang="ts" setup>

    import { ref } from "vue";
    import ProductCarousel from "@/components/ProductCarousel.vue";

    const bestSellerHeading = ref({
        text: 'Best Sellers'
    });
</script>